/* 3JIndustry Pro — page size + "Show more products" (owner 2026-11-05: "voir plus de pièces et même tous").
   - [data-per-page-select]: reloads the same address (filters and sort kept) with ?view=show-48 / show-96 / show-250,
     which picks the alternate templates templates/collection.show-*.json.
   - [data-load-more]: appends the next page of the same list through the Section Rendering API; repeat to reach every
     product. The numbered pagination stays as the no-script / fallback path.
   - [data-load-more][data-auto] (?view=show-all, owner 2026-11-05 "ajouter all"): the pages of 250 load one after the
     other by themselves until every product is on the page. */
(function () {
  if (window.__j3LoadMore) return;
  window.__j3LoadMore = true;

  document.addEventListener('change', function (e) {
    var s = e.target.closest && e.target.closest('[data-per-page-select]');
    if (!s) return;
    var u = new URL(window.location.href);
    if (s.value) u.searchParams.set('view', s.value); else u.searchParams.delete('view');
    u.searchParams.delete('page');
    window.location.href = u.toString();
  });

  function loadNext(btn) {
    var next = btn.getAttribute('data-next'), list = document.getElementById(btn.getAttribute('data-list'));
    if (!next || !list || btn.disabled) return;
    var label = btn.textContent, auto = btn.hasAttribute('data-auto');
    btn.disabled = true; btn.setAttribute('aria-busy', 'true');
    btn.textContent = (btn.getAttribute('data-loading') || '...') + (auto ? ' ' + label.replace(/^[^(]*/, '') : '');
    var url = next + (next.indexOf('?') < 0 ? '?' : '&') + 'section_id=' + encodeURIComponent(btn.getAttribute('data-section'));
    fetch(url, { headers: { Accept: 'text/html' }, credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(String(r.status)); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newList = doc.getElementById(list.id);
        var items = newList ? newList.querySelectorAll('.product-grid__item') : [];
        var first = null;
        Array.prototype.forEach.call(items, function (li) { var n = document.importNode(li, true); if (!first) first = n; list.appendChild(n); });
        var scope = btn.closest('.results__main') || document;
        var oldPag = scope.querySelector('.pagination'), newPag = doc.querySelector('.pagination');
        if (oldPag && newPag) oldPag.replaceWith(document.importNode(newPag, true));
        var newBtn = doc.querySelector('[data-load-more]');
        if (newBtn) {
          btn.setAttribute('data-next', newBtn.getAttribute('data-next'));
          btn.textContent = newBtn.textContent.trim();
          btn.disabled = false; btn.removeAttribute('aria-busy');
          if (auto) { setTimeout(function () { loadNext(btn); }, 150); return; }
        } else {
          var wrap = btn.closest('.load-more') || btn;
          wrap.parentNode.removeChild(wrap);
          if (auto) { var p = scope.querySelector('.pagination'); if (p) p.parentNode.removeChild(p); }
        }
        if (first && !auto) { var a = first.querySelector('a'); if (a) a.focus({ preventScroll: true }); }
      })
      .catch(function () {
        btn.disabled = false; btn.removeAttribute('aria-busy'); btn.textContent = label;
        btn.removeAttribute('data-auto');
        var msg = btn.parentNode && btn.parentNode.querySelector('.load-more__error');
        if (msg) msg.hidden = false;
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-load-more]');
    if (btn) loadNext(btn);
  });

  function autoStart() { var b = document.querySelector('[data-load-more][data-auto]'); if (b) loadNext(b); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', autoStart); else autoStart();
})();
